/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable func-names */
import isAvailableData from '../isAvailableData';

export default (RongIM) => {
    const Http = RongIM.dataModel._Http;
    const Cache = RongIM.dataModel._Cache;
    const ObserverList = RongIM.dataModel._ObserverList;
    const util = RongIM.dataModel.util;
    const store = RongIM.utils.cache;
    const generatorKey = util.generatorKey;
    const getStoreKey = util.getStoreKey;
    const getLibErrorCode = util.getLibErrorCode;
    const utils = RongIM.utils;

    let getCurrentConnectionStatus;

    let groupApi = null;
    let userApi = null;
    let friendApi = null;
    let messageApi = null;
    let statusApi = null;

    const Conversation = {
        isPullMessageFinished: true,
        draft: {},
        observerList: new ObserverList(),
        active: {
            conversationType: 0,
            targetId: '',
        },
    };

    const converObserverList = Conversation.observerList;

    Cache.conversation = {
        searchTempList: [],
    };

    Conversation.cleanCache = function () {
        Cache.conversation = {
            searchTempList: [],
        };
        Conversation.draft = {};
    };

    Conversation.loadApi = function () {
        const dataModel = RongIM.dataModel;
        groupApi = dataModel.Group;
        userApi = dataModel.User;
        friendApi = dataModel.Friend;
        messageApi = dataModel.Message;
        statusApi = dataModel.Status;
        getCurrentConnectionStatus = statusApi.getCurrentConnectionStatus;
    };

    function isGroup(conversationType) {
        return +conversationType === 3;
    }

    function debounceConversation() {
        converObserverList.notify();
    }

    /*
    获取置顶的会话
 */
    const getTopListFromRemote = function (callback) {
        const data = Cache.conversation;
        if (data.isSetting) {
            const settings = data.settings;
            callback(null, settings);
            return;
        }
        if (data._defer) {
            data._defer.done((result) => {
                callback(null, result);
            }).fail(callback);
            return;
        }
        data._defer = $.Deferred();
        Http.get('/conversation').done((result) => {
            const conversationSettings = result.settings;

            data.settings = conversationSettings;
            data.isSetting = true;

            callback(null, conversationSettings);
            data._defer.resolve(conversationSettings);
        }).fail((error) => {
            callback(error);
            data._defer.reject(error);
        });
    };

    // 判断 source 与 target 是否是同一会话
    const checkConversation = function (source, target) {
        return +source.conversation_type === +target.conversationType && source.target_id === target.targetId;
    };

    const delDuplicate = function (arr) {
        return arr.reduce((p, c) => {
        // create an identifying id from the object values
            const id = [c.conversation_type, c.target_id].join('|');

            // if the id is not found in the temp array
            // add the object to the output array
            // and add the key to the temp array
            if (p.temp.indexOf(id) === -1) {
                p.out.push(c);
                p.temp.push(id);
            }
            return p;

            // return the deduped array
        }, { temp: [], out: [] }).out;
    };

    /*
    1. 取出置顶会话
    2. 将置顶会话合并到会话中
    3. 会话排序
*/
    function splitTopConversation(list, callback) {
    // 1、获取置顶数组 √
    // 2、匹配会话列表 List √
    // 3、按 sentTime 排序置顶 √
    // 4、追加到 list 中，保证操作的是同一个对象 √
        const tempList = [];

        const mergeConversation = function (topList) {
            if (util.isArray(topList)) {
                const idxs = [];
                for (let i = 0; i < topList.length; i += 1) {
                    const topConversation = topList[i];
                    for (let j = 0; j < list.length; j += 1) {
                        const conversation = list[j];
                        if (checkConversation(topConversation, conversation)) {
                            conversation.isTop = topConversation.top;
                            conversation.notificationStatus = topConversation.not_disturb;
                            if (conversation.isTop) {
                                idxs.push(j);
                                tempList.push(conversation);
                            }
                        }
                    }
                }

                idxs.sort((a, b) => b - a);
                for (let k = 0; k < idxs.length; k += 1) {
                    list.splice(idxs[k], 1);
                }
            }
        };

        const buildConversationList = function (result) {
            mergeConversation(result);
            tempList.sort((a, b) => b.sentTime - a.sentTime);
            tempList.reverse();
            // TODO 暂时做法，后期会话列表统一优化
            list.sort((a, b) => b.sentTime - a.sentTime);
            for (let i = 0, len = tempList.length; i < len; i += 1) {
                list.unshift(tempList[i]);
            }
            callback([].concat(list));
        };

        getTopListFromRemote((errorCode, result) => {
            if (errorCode) {
                utils.console.warn(errorCode);
                return;
            }
            // utils.console.log(result);
            // 服务端 toplist 有重复,需加入排重
            const _list = delDuplicate(result);
            if (!Cache.conversation.topList) {
                Cache.conversation.topList = _list;
            }
            buildConversationList(Cache.conversation.topList);
        });
    }
    Conversation.splitTopConversation = splitTopConversation;

    // 会话列表分页，置顶会话缺失，获取缺失的会话
    function getOtherTopList(list, callback) {
        const _list = [];
        let tempIdList = [];
        tempIdList = list.map(con => con.targetId + con.conversationType);
        getTopListFromRemote((errorCode, result) => {
            if (errorCode) {
                utils.console.warn(errorCode);
                return;
            }
            // utils.console.log(result);
            // 服务端 toplist 有重复,需加入排重
            const _result = delDuplicate(result);

            const allTopList = _result.filter(con => con.top);
            const otherTopList = allTopList.filter(con => tempIdList.indexOf(con.target_id + con.conversation_type) < 0);
            if (otherTopList.length === 0) {
                callback(null, []);
                return;
            }
            const promiseList = [];
            const deferList = [];
            for (let i = 0; i < otherTopList.length; i += 1) {
                const defer = $.Deferred();
                const promise = defer.promise();
                deferList.push(defer);
                promiseList.push(promise);
            }
            otherTopList.forEach((con, index) => {
                Conversation.getOneWithoutInfo(con.conversation_type, con.target_id, (error, conversation) => {
                    if (error) {
                        utils.console.warn(error);
                        deferList[index].reject(error);
                        return;
                    }
                    if (conversation.latestMessage) {
                        _list.push(conversation);
                    }
                    deferList[index].resolve();
                });
            });
            $.when.apply(null, promiseList).done(() => {
                callback(null, _list);
            }).fail((error) => {
                callback(error);
            });
        });
    }

    function addConversationUserInfo(list, callback) {
        callback = callback || $.noop;
        const ConversationType = RongIMLib.ConversationType;
        const isGroupConversation = function (item) {
            return item.conversationType === ConversationType.GROUP;
        };
        const isUser = function (item) {
            return item.conversationType === ConversationType.PRIVATE || item.conversationType === ConversationType.SYSTEM;
        };
        const isPublic = function (item) {
            return item.conversationType === ConversationType.APP_PUBLIC_SERVICE;
        };

        const bindInfo = function () {
            const addMessageUserInfo = function (latestMessage, groupAlias) {
                messageApi.fixSendMessageBug(latestMessage);
                const senderUserId = latestMessage.senderUserId;
                userApi.get(senderUserId, (errorCode, user) => {
                    if (errorCode) {
                        utils.console.warn(`获取用户信息失败（错误码：${errorCode}）`);
                        latestMessage.user = {};
                    } else if (groupAlias) {
                        const _user = $.extend({}, user);
                        _user.groupAlias = groupAlias;
                        latestMessage.user = _user;
                    } else {
                        latestMessage.user = user;
                    }
                });
            };

            list.forEach((item) => {
                if (isGroupConversation(item)) {
                    item.group = {};
                    groupApi.getOne(item.targetId, (errorCode, group) => {
                        if (errorCode) {
                            utils.console.warn(`获取群组信息失败, groupId=${item.targetId}（错误码：${errorCode}）`);
                            groupApi.getOne(item.targetId, (_errorCode, _group) => {
                                if (_errorCode) {
                                    utils.console.warn(`获取群组信息失败, groupId=${item.targetId}（错误码：${_errorCode}）`);
                                } else {
                                    item.group = _group;
                                    let groupAlias = '';
                                    if (_group.members && item.latestMessage) {
                                        groupAlias = groupApi.getGroupAlias(item.latestMessage.senderUserId, _group.members);
                                    }
                                    addMessageUserInfo(item.latestMessage, groupAlias);
                                }
                            });
                        } else {
                            item.group = group;
                            let groupAlias = '';
                            if (group.members && item.latestMessage) {
                                groupAlias = groupApi.getGroupAlias(item.latestMessage.senderUserId, group.members);
                            }
                            addMessageUserInfo(item.latestMessage, groupAlias);
                        }
                    });
                } else if (isUser(item) || isPublic(item)) {
                    if (friendApi.isFileHelper(item.targetId)) {
                        item.user = friendApi.getFileHelper();
                    } else {
                        item.user = {};
                    }
                    const userId = item.targetId;
                    userApi.get(userId, (errorCode, user) => {
                        if (errorCode) {
                            utils.console.warn(`获取用户信息失败, userId=${userId}(错误码：${errorCode})`);
                            userApi.get(userId, (_errorCode, _user) => {
                                if (_errorCode) {
                                    utils.console.warn(`获取用户信息失败, userId=${userId}(错误码：${_errorCode})`);
                                } else {
                                    item.user = _user;
                                }
                                if (!_user) {
                                    Conversation.remove(item.conversationType, item.targetId);
                                    // TODO: 确定是否是要做过滤，若是需修改算法，不要 forEach
                                    list.forEach((conv, index) => {
                                        if (util.sameConversation(item, conv)) {
                                            list.splice(index, 1);
                                        }
                                    });
                                }
                                addMessageUserInfo(item.latestMessage);
                            });
                        } else {
                            item.user = user;
                            if (!user) {
                                Conversation.remove(item.conversationType, item.targetId);
                                // TODO: 确认是否是要过滤，如果是要过滤，不要用 forEach
                                list.forEach((conv, index) => {
                                    if (util.sameConversation(item, conv)) {
                                        list.splice(index, 1);
                                    }
                                });
                            }
                            addMessageUserInfo(item.latestMessage);
                        }
                    });
                }
            });
            const error = null;
            callback(error, list);
        };

        const getIds = function (items) {
            return items.map(item => item.targetId);
        };

        const groups = list.filter(isGroupConversation);
        const groupIds = getIds(groups);

        const users = list.filter(isUser);
        let userIds = getIds(users);

        const senderIds = list.map(item => item.latestMessage.senderUserId);
        userIds = userIds.concat(senderIds);
        const unique = function (arr) {
            const tmp = {};
            return arr.filter((item) => {
                if (tmp[item]) {
                    return false;
                }
                tmp[item] = true;
                return true;
            });
        };
        userIds = unique(userIds);

        $.when(groupApi.getBatchGroups(groupIds), userApi.getUsers(userIds)).then(() => {
            bindInfo();
        });
    }

    /**
 * @params.count 返回 count 个会话;如果会话总数 total < count 则返回 total 个会话
 */
    const getInitConversationList = function (count, callback, callbackHasUserinfo) {
        callback = callback || $.noop;
        if (!Conversation.isPullMessageFinished) {
            return;
        }
        if (!isAvailableData()) {
            const status = getCurrentConnectionStatus();
            const errorCode = `status-${status}`;
            callback(errorCode);
            return;
        }
        const ConversationType = RongIMLib.ConversationType;
        // var isGroup = function (type) {
        //     return type === ConversationType.GROUP;
        // };
        const isUser = function (type) {
            return type === ConversationType.PRIVATE;
        };
        const isPublic = function (type) {
            return type === ConversationType.APP_PUBLIC_SERVICE;
        };
        const isSystem = function (type) {
            return type === ConversationType.SYSTEM;
        };
        // callback(null, []);
        // RongIMClient.getInstance().getConversationList({
        const conversation = {
            types: [1, 2, 3, 4, 5, 7, 8],
            sentTime: 0,
            count,
        };
        RongIMClient.getInstance().getConversationsByPage(conversation, {
            onSuccess(list) {
                getOtherTopList(list, (error, _otherList) => {
                // 排除系统会话，会话列表不显示系统会话(朋友圈的消息)
                    list = list.filter(item => !isSystem(item.conversationType));
                    if (count > 0) {
                        list.length = list.length < count ? list.length : count;
                    }
                    list = list.concat(_otherList);
                    const searchList = Cache.conversation.searchTempList;
                    const searchObj = {};
                    const keys = [];

                    searchList.forEach((item) => {
                        const key = generatorKey([item.conversationType, item.targetId]);
                        searchObj[key] = 1;
                    });

                    list.forEach((item) => {
                        messageApi.hackWebSDKMessage(item.latestMessage);
                        const type = item.conversationType;
                        const targetId = item.targetId;
                        const key = generatorKey([type, targetId]);
                        const has = (key in searchObj);
                        if (has) {
                            keys.push(key);
                        }
                        // 置顶和免打扰置为默认值 false, 然后从缓存中匹配置顶和免打扰设置
                        item.isTop = false;
                        item.notificationStatus = false;
                        if (isUser(type) || isPublic(type)) {
                            if (friendApi.isFileHelper(targetId)) {
                                item.user = friendApi.getFileHelper();
                            } else {
                                item.user = Cache.user[targetId] || {};
                            }
                        }
                        // if(isPublic(type)) {
                        //     item.user = item.latestMessage;
                        // }
                        const message = item.latestMessage;
                        const senderUserId = message.senderUserId;
                        const msgUser = Cache.user[senderUserId] || {};
                        if (isGroup(type)) {
                            item.group = Cache.group[targetId] || {};
                            let groupAlias = '';
                            if (item.group.members) {
                                groupAlias = groupApi.getGroupAlias(senderUserId, item.group.members);
                            }
                            const _user = $.extend({}, msgUser);
                            _user.groupAlias = groupAlias;
                            message.user = _user;
                        } else {
                            message.user = msgUser;
                        }
                        item.draft = Conversation.getDraft(item.conversationType, item.targetId);
                    });
                    searchList.forEach((item, index) => {
                        item.isTop = false;
                        item.notificationStatus = false;
                        const type = item.conversationType;
                        const targetId = item.targetId;
                        keys.forEach((key) => {
                            if (generatorKey([type, targetId]) === key) {
                                searchList.splice(index, 1);
                            }
                        });
                        item.draft = Conversation.getDraft(item.conversationType, item.targetId);
                    });
                    list = searchList.concat(list);
                    splitTopConversation(list, (result) => {
                        Cache.conversation.list = result;
                        bindConversationRequestMsgs(result);
                        addConversationUserInfo(result, callbackHasUserinfo);
                        callback(null, result);
                    });
                });
            },
            onError(error) {
                callback(getLibErrorCode(error));
            },
        }, null);
    };

    // 返回全部会话
    const getConversationList = function (callback, callbackHasUserinfo) {
        callback = callback || $.noop;
        getInitConversationList(0, callback, callbackHasUserinfo);
    };

    // todo: bindConversationRequestMsgs 备注
    function bindConversationRequestMsgs(list) {
        const storeKey = getStoreKey('req');
        const data = store.get(storeKey) || {};
        list.forEach((item) => {
            const conversationKey = generatorKey([item.conversationType, item.targetId]);
            item.requestMsgs = data[conversationKey];
        });
    }

    // 获取会话详细信息
    function getConversationInfo(conversation, callback) {
        const conversationType = conversation.conversationType;
        const targetId = conversation.targetId;
        const getInfo = isGroup(conversationType) ? groupApi.getOne : userApi.getVisitors;
        getInfo(targetId, done, true);
        function done(errorCode, result) {
            if (errorCode) {
                callback(errorCode);
                return;
            }
            const type = isGroup(conversationType) ? 'group' : 'user';
            conversation[type] = result || {};
            bindConversationRequestMsgs([conversation]);
            Conversation.getExpandInfo(conversation, (error, topMute) => {
                conversation.isTop = topMute.top;
                conversation.notificationStatus = topMute.not_disturb;
                callback(null, conversation);
            });
        }
    }

    Conversation.notifyConversation = RongIM.utils.throttle(debounceConversation, 600);

    // 创建一条新会话
    const createConversation = function (params) {
        const reset = util.reset;
        const sentTime = +new Date();
        const data = {
            conversationType: 0,
            isTop: false,
            latestMessage: {
                sentTime,
                messageType: 'TextMessage',
                content: '',
            },
            notificationStatus: false,
            receivedStatus: 0,
            targetId: '',
            sentTime,
            unreadMessageCount: 0,
        };
        reset(data, params);
        const conversation = new RongIMLib.Conversation();
        reset(conversation, data);
        messageApi.get({
            targetId: conversation.targetId,
            conversationType: conversation.conversationType,
        }, (error, list) => {
            if (list && list.length > 0) {
                conversation.latestMessage = list[list.length - 1];
            }
        });
        return conversation;
    };

    // 插入一条新会话
    Conversation.add = function (params, callback) {
        callback = callback || $.noop;
        const type = params.conversationType;
        const targetId = params.targetId;
        const isSame = function (item) {
            return item.conversationType === type && item.targetId === targetId;
        };
        const filter = function (item) {
            return isSame(item);
        };
        const cacheList = Cache.conversation.list || [];
        const list = cacheList.filter(filter);
        const isExist = (list.length > 0);
        if (!isExist) {
            const conversation = createConversation(params);
            const typeKey = isGroup(type) ? 'group' : 'user';
            conversation[typeKey] = {};
            conversation.latestMessage = params.latestMessage || conversation.latestMessage;
            const getIndex = function () {
                let topList = Cache.conversation.topList || [];
                topList.forEach((item) => {
                    if (checkConversation(item, conversation)) {
                        conversation.isTop = item.top;
                        conversation.notificationStatus = item.not_disturb;
                    }
                });
                topList = topList.filter(item => item.top);
                const getKey = function (item) {
                    return generatorKey([item.conversationType, item.targetId]);
                };
                const has = function (key, obj) {
                    return (key in obj);
                };
                let index = 0;
                if (!conversation.isTop) {
                    const topObj = {};
                    topList.forEach((item) => {
                    // var key = getKey(item);
                        const key = generatorKey([item.conversation_type, item.target_id]);
                        topObj[key] = 1;
                    });
                    cacheList.forEach((item) => {
                        const key = getKey(item);
                        if (has(key, topObj)) index += 1;
                    });
                }
                return index;
            };
            const insert = function () {
                const index = getIndex();
                cacheList.splice(index, 0, conversation);
            };
            Cache.conversation.searchTempList.unshift(conversation);
            insert();
            RongIMClient.getInstance().addConversation(conversation);
            getConversationInfo(conversation, () => {
                converObserverList.notify(cacheList);
                callback(conversation);
            });
        }
    };

    // 增加文件助手
    Conversation.addFileHelper = function () {
        const key = `phoneLogined-${Cache.auth.id}`;
        const isLogined = store.get(key);
        if (!isLogined) {
            friendApi.getFileHelper((err, fileHelper) => {
                if (!err) {
                    const params = {
                        targetId: fileHelper.id,
                        conversationType: RongIMLib.ConversationType.PRIVATE,
                        user: fileHelper,
                    };
                    Conversation.add(params, () => {
                        const arg = {
                            targetId: params.targetId,
                            conversationType: params.conversationType,
                            objectName: 'RC:InfoNtf',
                            sentStatus: RongIMLib.SentStatus.SENT,
                            content: {
                                message: RongIM.config.currentLocale().components.getFileHelper.desc,
                            },
                        };
                        messageApi.insertMessage(arg);
                    });
                    const list = Cache.conversation.list || [];
                    converObserverList.notify(list);
                    store.set(key, true);
                }
            });
        }
    };

    Conversation.getInitList = function (count, callback) {
        getInitConversationList(count, callback);
    };

    Conversation.getList = function (callback, callbackHasUserinfo) {
        getConversationList(callback, callbackHasUserinfo);
    };

    // 返回缓存中的会话
    Conversation.getLocalList = function () {
        return Cache.conversation.list || [];
    };

    /*
    获取原始会话数据
    主要用于计算未读消息数; 搜索时判断会话是否存在以保证能正确定位
*/
    Conversation.getNativeList = function (callback) {
        callback = callback || $.noop;
        if (!isAvailableData()) {
            const status = getCurrentConnectionStatus();
            const errorCode = `status-${status}`;
            callback(errorCode);
            return;
        }
        const ConversationType = RongIMLib.ConversationType;
        const isSystem = function (type) {
            return type === ConversationType.SYSTEM;
        };
        RongIMClient.getInstance().getConversationList({
            onSuccess(list) {
            // 排除系统会话，会话列表不显示系统会话(朋友圈的消息)
                list = list.filter(item => !isSystem(item.conversationType));
                callback(null, list);
            },
            onError(error) {
                callback(getLibErrorCode(error));
            },
        }, null);
    };

    // 根据 conversationType, targetId 获取缓存会话
    Conversation.getLocalOne = function (conversationType, targetId) {
        let conversation = null;
        const list = Conversation.getLocalList();
        list.some((item) => {
            const sameConversation = +item.conversationType === +conversationType && item.targetId === targetId;
            if (sameConversation) {
                conversation = item;
            }
            return sameConversation;
        });
        return conversation;
    };

    // 根据 conversationType, targetId 从接口获取会话
    Conversation.getOne = function (conversationType, targetId, callback) {
        callback = callback || $.noop;
        // const lconv = Conversation.getLocalOne(conversationType, targetId);
        // if (lconv) {
        //     callback(null, lconv);
        //     return;
        // }
        RongIMClient.getInstance().getConversation(+conversationType, targetId, {
            onSuccess(conversation) {
                if (!conversation) {
                // 会话不存在新建一个
                    conversation = {
                        targetId,
                        conversationType,
                        unreadMessageCount: 0,
                    };
                }

                getConversationInfo(conversation, callback);
            },
            onError(errorCode) {
                callback(errorCode);
            },
        });
    };

    Conversation.getOneWithoutInfo = function (conversationType, targetId, callback) {
        callback = callback || $.noop;
        const lconv = Conversation.getLocalOne(conversationType, targetId);
        if (lconv) {
            callback(null, lconv);
            return;
        }
        RongIMClient.getInstance().getConversation(+conversationType, targetId, {
            onSuccess(conversation) {
                if (!conversation) {
                // 会话不存在新建一个
                    conversation = {
                        targetId,
                        conversationType,
                        unreadMessageCount: 0,
                    };
                }
                callback(null, conversation);
            },
            onError(errorCode) {
                callback(errorCode);
            },
        });
    };

    // 获取单条会话未读数
    Conversation.getUnreadCount = function (conversation) {
        const callbacks = {
            onSuccess() {},
            onError() {},
        };
        const type = conversation.conversationType || conversation.conversation_type;
        const targetId = conversation.targetId || conversation.target_id;
        return RongIMClient.getInstance().getUnreadCount(Number(type), targetId, callbacks);
    };

    // 获取总未读数
    Conversation.getTotalUnreadCount = function (list, callback) {
        callback = callback || $.noop;
        const conversationTypes = [
            RongIMLib.ConversationType.PRIVATE,
            RongIMLib.ConversationType.GROUP,
            RongIMLib.ConversationType.APP_PUBLIC_SERVICE,
        ];
        let total = 0;
        list.forEach((item) => {
            if (!item.notificationStatus && conversationTypes.indexOf(item.conversationType) !== -1) {
                total += item.unreadMessageCount;
            }
        });
        if (list.length > 0) {
            callback(null, total);
            return;
        }
        const callbacks = {
            onSuccess() {},
            onError() {},
        };

        total = RongIMClient.getInstance().getTotalUnreadCount(callbacks, conversationTypes);
        getTopListFromRemote((error, settingList) => {
            if (error) {
                callback(error, settingList);
                return;
            }
            let muteCount = 0;
            settingList.forEach((conversation) => {
                if (conversation.not_disturb) {
                    muteCount += Conversation.getUnreadCount(conversation);
                }
            });
            total -= muteCount;
            if (total < 0) {
                total = 0;
            }
            callback(error, total);
        });
    };

    Conversation.clearUnReadCount = function (conversationType, targetId, callback) {
        callback = callback || $.noop;
        // 类型转换 SDK 要求 number 类型
        conversationType = +conversationType;
        RongIMClient.getInstance().getConversation(conversationType, targetId, {
            onSuccess(conversation) {
                if (!conversation) {
                    return;
                }
                bindConversationRequestMsgs([conversation]);
                if (conversation.unreadMessageCount > 0) {
                    clearUnreadCount(conversationType, targetId, callback);
                    if (conversationType === RongIMLib.ConversationType.PRIVATE) {
                        messageApi.sendReadStatus(conversation.latestMessage);
                    } else {
                        messageApi.sendSyncReadStatusMessage(conversation.latestMessage);
                    }
                    if (isGroup(conversationType) && conversation.requestMsgs) {
                        messageApi.sendGroupResponse(conversationType, targetId, conversation.requestMsgs);
                    }
                }
            },
            onError(errorCode) {
                callback(errorCode);
            },
        });
    };

    function clearUnreadCount(conversationType, targetId, callback) {
        callback = callback || $.noop;
        RongIMClient.getInstance().clearUnreadCount(conversationType, targetId, {
            onSuccess() {
                const list = Conversation.getLocalList();
                const conversation = Conversation.getLocalOne(conversationType, targetId);
                if (conversation) {
                    conversation.unreadMessageCount = 0;
                    converObserverList.notify(list);
                }
                callback();
            },
            onError(errorCode) {
                callback(getLibErrorCode(errorCode));
            },
        });
    }

    Conversation.clearUnreadCount = clearUnreadCount;

    Conversation.getDraft = function (conversationType, targetId) {
        const path = `${conversationType}/${targetId}`;
        return Conversation.draft[path] || { content: '', atMembers: [] };
    };

    Conversation.setDraft = function (conversationType, targetId, draft) {
        const path = `${conversationType}/${targetId}`;
        Conversation.draft[path] = draft;
        const conversation = Conversation.getLocalOne(conversationType, targetId);
        if (conversation) {
            conversation.draft = draft;
            const list = Conversation.getLocalList();
            converObserverList.notify(list);
        }
    };

    Conversation.clearDraft = function (conversationType, targetId) {
        Conversation.setDraft(conversationType, targetId, '');
        const conversation = Conversation.getLocalOne(conversationType, targetId);
        if (conversation) {
            conversation.draft = {
                atMembers: [],
                content: '',
            };
            const list = Conversation.getLocalList();
            converObserverList.notify(list);
        }
    };

    Conversation.remove = function (conversationType, targetId, callback) {
        callback = callback || $.noop;
        if (!isAvailableData()) {
            const status = getCurrentConnectionStatus();
            const errorCode = `status-${status}`;
            callback(errorCode);
            return;
        }
        const isSame = function (item) {
            return item.conversationType === conversationType && item.targetId === targetId;
        };
        const searchList = Cache.conversation.searchTempList;
        searchList.forEach((item, index) => {
            if (isSame(item)) {
                searchList.splice(index, 1);
            }
        });
        RongIMClient.getInstance().removeConversation(conversationType, targetId, {
            onSuccess(bool) {
                if (bool) {
                    const list = Conversation.getLocalList();
                    const item = Conversation.getLocalOne(conversationType, targetId);
                    const index = list.indexOf(item);
                    if (index > -1) {
                        list.splice(index, 1);
                    }
                    converObserverList.notify(list);
                    callback();
                } else {
                    callback(bool);
                }
            },
            onError(error) {
                callback(getLibErrorCode(error));
            },
        });
    };

    /*
正在会话的会话，切换会话时调用
var active = {
    conversationType: 1,
    targetId: ''
};
*/
    Conversation.setActive = function (active) {
        Conversation.active = active;
    };

    const toggleTop = function (conversationType, targetId, isTop, callback) {
        callback = callback || $.noop;
        const item = {
            1() {
                const topObj = {
                    conversation_type: conversationType,
                    target_id: targetId,
                    top: true,
                    not_disturb: false,
                };
                let notHave = true;
                const topList = Cache.conversation.topList || [];
                for (let i = 0; i < topList.length; i += 1) {
                    const temp = topList[i];
                    if (+temp.conversation_type === +conversationType && temp.target_id === targetId) {
                        temp.top = true;
                        notHave = false;
                    }
                }
                if (notHave) topList.push(topObj);
            },
            0() {
                const topList = Cache.conversation.topList || [];
                for (let i = 0; i < topList.length; i += 1) {
                    const temp = topList[i];
                    if (+temp.conversation_type === +conversationType && temp.target_id === targetId) {
                        if (temp.not_disturb) {
                            temp.top = false;
                        } else {
                            topList.splice(i, 1);
                        }
                    }
                }
            },
        };
        Http.put('/conversation/top', {
            conversation_type: conversationType,
            target_id: targetId,
            top: isTop,
        }).done((result) => {
        // if(isTop === 1){
        //     Cache.conversation.isSetting = false;
        //     Cache.conversation._defer = null;
        // }
            item[isTop]();
            callback(null, result);
        // Conversation.getList(function (errorCode, list) {
        //     if (errorCode) {
        //         return callback( errorCode);
        //     }
        //     converObserverList.notify(list);
        // });
        }).fail(callback);
    };
    // 置顶
    Conversation.top = function (conversationType, targetId, callback) {
        toggleTop(conversationType, targetId, 1, callback);
    };
    // 取消置顶
    Conversation.untop = function (conversationType, targetId, callback) {
        toggleTop(conversationType, targetId, 0, callback);
    };

    Conversation.search = function (keyword, callback) {
        callback = callback || $.noop;
        if (!isAvailableData()) {
            const status = getCurrentConnectionStatus();
            const errorCode = `status-${status}`;
            callback(errorCode);
            return;
        }

        RongIMClient.getInstance().searchConversationByContent(keyword, {
            onSuccess(conversationList) {
                addConversationUserInfo(conversationList, (error, list) => {
                // 补充搜索到几条消息。TODO: 希望 SDK 可以支持
                    if (error) {
                        callback(getLibErrorCode(error));
                        return;
                    }
                    callback(null, list);
                });
            },
            onError(code) {
                callback(code);
            },
        }, undefined, ['RCE:GrpNoticeNtfy']);
    };

    const toggleMute = function (conversationType, targetId, isMute, callback) {
        callback = callback || $.noop;
        const item = {
            1() {
                const topObj = {
                    conversation_type: conversationType,
                    target_id: targetId,
                    top: false,
                    not_disturb: true,
                };
                let notHave = true;
                const topList = Cache.conversation.topList || [];
                for (let i = 0; i < topList.length; i += 1) {
                    const temp = topList[i];
                    if (+temp.conversation_type === +conversationType && temp.target_id === targetId) {
                        temp.not_disturb = true;
                        notHave = false;
                    }
                }
                if (notHave) topList.push(topObj);
            },
            0() {
                const topList = Cache.conversation.topList || [];
                for (let i = 0; i < topList.length; i += 1) {
                    const temp = topList[i];
                    if (+temp.conversation_type === +conversationType && temp.target_id === targetId) {
                        if (temp.top || temp.not_disturb) {
                            temp.not_disturb = false;
                        } else {
                            topList.splice(i, 1);
                        }
                    }
                }
            },
        };
        Http.put('/conversation/notdisturb', {
            conversation_type: conversationType,
            target_id: targetId,
            not_disturb: isMute,
        }).done((result) => {
            // if(isMute === 1){
            //     Cache.conversation.isSetting = false;
            //     Cache.conversation._defer = null;
            // }
            item[isMute]();
            callback(null, result);

            const list = Conversation.getLocalList();
            const conversation = Conversation.getLocalOne(conversationType, targetId);
            // TODO: conversation 可能是空值，需要排查空值的原因
            // 复现方式：删除会话列表中的公众号，通过搜索该公众号公众号会话窗口，点击弹出公众号设置面板，操作 switch 组件
            if (conversation) {
                conversation.notificationStatus = isMute === 1;
                converObserverList.notify(list);
            }
        }).fail(callback);
    };

    function getExpandInfo(type, id) {
        let result = {};
        Cache.conversation.topList.forEach((item) => {
            if (+item.conversation_type === +type && item.target_id === id) {
                result = item;
            }
        });
        return result;
    }

    /*
会话相关详细信息
params.conversationType 会话类型
params.targetId 会话 Id
*/
    Conversation.getExpandInfo = function (params, callback) {
        const type = params.conversationType;
        const id = params.targetId;
        callback = callback || $.noop;
        if (Cache.conversation.topList) {
            const expandInfo = getExpandInfo(type, id);
            callback(null, expandInfo);
        } else {
            getTopListFromRemote((errorCode, list) => {
                Cache.conversation.topList = list || [];
                const result = getExpandInfo(type, id);
                callback(null, result);
            });
        }
    };

    // 免打扰
    Conversation.mute = function (conversationType, targetId, callback) {
        toggleMute(conversationType, targetId, 1, callback);
    };
    // 取消免打扰
    Conversation.unmute = function (conversationType, targetId, callback) {
        toggleMute(conversationType, targetId, 0, callback);
    };

    Conversation.watch = function (handle) {
        converObserverList.add(handle);
    };

    Conversation.unwatch = function (handle) {
        converObserverList.remove(handle);
    };

    RongIM.dataModel.Conversation = Conversation;
};
